import { TermsAndCondition } from "../../state/scheduler.store";
import { baseUrlServer } from "./common";
import { axiosWithRetry } from "./utils/axiosRetry";

export const getTermsAndConditions = async (requestPayload: {
  client: string;
}) => {
  const url = `${baseUrlServer}/settings/termsAndConditions?client=${requestPayload.client}&includeRoosterTerms=true`;
  try {
    const response = await axiosWithRetry(url, "get", { timeout: 120000 });
    const json = (await response.data) as TermsAndCondition[];
    return json;
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error(error?.message);
    }
  }
};
